<div class="{{ border ? 'chart-container' : '' }}">
  <div
    echarts
    [options]="chartOption"
    [style.width]="width"
    [style.height]="height"
    class="chart"
  ></div>
</div>
